export default __webpack_public_path__ + "static/media/F0004.b42708e0.png";